import { Label } from './styles';

//https://codepen.io/garetmckinley/pen/YmxYZr

type Props = {
    value: boolean;
    setValue: (value: boolean) => void;
};

const ToggleSwitch = ({ value, setValue }: Props) => {
    return (
        <Label>
            <input
                type="checkbox"
                checked={value}
                onChange={() => setValue(!value)}
            />
            <span></span>
        </Label>
    );
};

export default ToggleSwitch;
